import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../../utilities/props.js";
import s from "./Progress.module.css";
const Progress = (props) => {
    const { value = 0, min = 0, max = 100, color = "primary", size = "medium", duration, ariaLabel, className, attributes, } = props;
    const rootClassNames = classNames(s.root, className, color && s[`--color-${color}`], size && s[`--size-${size}`], !!duration && s["--duration"]);
    const total = max - min;
    const normalizedValue = value - min;
    const resolvedValue = Math.max(min, Math.min(max, normalizedValue));
    const width = (resolvedValue / total) * 100;
    const translate = `${width - 100}%`;
    return (_jsx("div", { role: "progressbar", ...attributes, className: rootClassNames, "aria-label": ariaLabel || attributes?.["aria-label"], "aria-valuemax": max, "aria-valuemin": min, "aria-valuenow": value, children: _jsx("div", { className: s.value, style: {
                "--rs-progress-value": translate,
                "--rs-progress-duration": duration ? `${duration}ms` : undefined,
            } }) }));
};
Progress.displayName = "Progress";
export default Progress;
